module.exports = {
      id: "whatsapp-usage",
      viewBox: "0 0 38.254 38.254",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#whatsapp",
      toString: function () {
        return this.url;
      }
    }